<script setup lang="ts">
// import { useSchemaOrg, defineWebSite, defineWebPage } from '@unhead/schema-org'
import '@unocss/reset/tailwind.css'
// import Snowflakes from 'magic-snowflakes'
//
// onMounted(() => {
//   if (process.browser) {
//     const snowflakes = new Snowflakes()
//   }
// })

useSchemaOrg([
  defineWebSite({
    name: 'Crappy Stats for OTB\'s Crappy Quiz',
  }),
  defineWebPage(),
])
// if (process.browser) {
//   useBlobity({
//     licenseKey: 'opensource',
//     zIndex: 1000,
//     // color: '#ff8700',
//     // opacity: 3.3,
//     invert: true,
//     dotColor: 'green',
//     radius: 5
//   })
// }
</script>

<template>
  <Html lang="en-IE">

  <Head>
    <!--      <Meta name="apple-mobile-web-app-status-bar" content="red" /> -->
    <!--      <Meta name="theme-color" content="#319197" media="(prefers-color-scheme: light)"/> -->
    <!--      <Meta name="theme-color" content="#872e4e" media="(prefers-color-scheme: dark)"/> -->
    <Meta name="viewport" content="width=device-width, initial-scale=1" />
  </Head>

  <div style="scrollbar-gutter: stable">
    <NuxtLayout name="custom">
      <NuxtLoadingIndicator />
      <NuxtPage />
    </NuxtLayout>
  </div>

  </Html>
</template>

<style></style>
